import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app/app.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { environment } from '../environments/environment';

registerLocaleData(localeFr);

@NgModule({
  imports: [
    // angular
    BrowserAnimationsModule,
    BrowserModule,

    HttpClientJsonpModule,
    HttpClientModule,

    // core & shared
    CoreModule,
    SharedModule,

    // app
    AppRoutingModule

    // MatGoogleMapsAutocompleteModule.forRoot(environment.keys.google.apiKey)
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: LOCALE_ID, useValue: 'fr-FR' }
  ]
})
export class AppModule {}
